import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-about-tanuh',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-tanuh.component.html',
  styleUrl: './about-tanuh.component.scss',
})
export class AboutTanuhComponent {}
